import React, { useState } from 'react';
import { Result, Col, Spin } from 'antd';
import PropTypes from 'prop-types';
import { Button, Text } from 'components';
import { ReloadOutlined } from '@ant-design/icons';

const styles = {
  body: {
    position: 'fixed',
    zIndex: 9999,
    top: '50%',
    left: '50%',
    minWidth: '100%',
    minHeight: '100%',
    transform: 'translate(-50%, -50%)',
    backgroundColor: 'rgba(255, 255, 255, 1)',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  spin: {
    fontSize: '30px',
    margin: '0px 0px 0px 0px',
    padding: '0px 0px 0px 0px',
    color: 'rgba(0, 0, 0, 0.85)',
  },
};

const CustomResult = ({
  visible,
  generado,
  retryFunc,
}) => {
  const [loading, setLoading] = useState(true);

  if (!visible) {
    return null;
  }

  const getStatus = () => {
    if (loading) {
      return 'info';
    }
    return generado ? 'success' : 'warning';
  };

  const getTitle = () => {
    if (loading) {
      return 'Generando...';
    }
    return generado ? 'El recibo ha sido generado con éxito.' : 'Ha ocurrido un error al generar el recibo.';
  };

  const getSubTitle = () => {
    if (loading) {
      return 'Espere un momento por favor.';
    }
    return !(generado) ? (
      <>
        <p>Por favor, intente nuevamente.</p>
        <p>Si el problema persiste, contacte a soporte técnico.</p>
        <Button onClick={retryFunc} $accent>
          <Text>Reintentar</Text>
          <ReloadOutlined />
        </Button>
      </>
    ) : '';
  };

  const getIcon = () => {
    if (loading) {
      return <Spin spinning size="large" style={styles.spin} tip="" />;
    }
    return null;
  };

  // if loading is true during 1 minute, show error message
  if (loading) {
    setTimeout(() => {
      if (loading) {
        setLoading(false);
      }
    }, 60000);
  }

  return (
    <Col md={24}>
      <Result
        style={styles.body}
        status={getStatus()}
        icon={getIcon()}
        title={getTitle()}
        subTitle={getSubTitle()}
      />
    </Col>
  );
};

CustomResult.propTypes = {
  visible: PropTypes.bool,
  generado: PropTypes.bool,
  retryFunc: PropTypes.func.isRequired,
};

CustomResult.defaultProps = {
  visible: false,
  generado: false,
};

export default CustomResult;
